import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'charactersLeft'
})
export class CharactersLeftPipe implements PipeTransform {
  transform(value: string, total: number): string {
    return `${value.length}/${total}`;
  }
}
